import { useEffect, useRef } from 'react';

export default function ParticleCanvas({ className = '' }) {
    const ref = useRef(null);

    useEffect(() => {
        const canvas = ref.current;
        const ctx = canvas.getContext('2d');
        let raf;
        let w, h;
        const particles = Array.from({ length: 70 }, () => ({
            x: Math.random(),
            y: Math.random(),
            r: Math.random() * 1.6 + 0.4,
            vx: (Math.random() - 0.5) * 0.0004,
            vy: -(Math.random() * 0.0006 + 0.0002),
            tw: Math.random() * Math.PI * 2,
        }));

        const resize = () => {
            w = canvas.width = canvas.offsetWidth * window.devicePixelRatio;
            h = canvas.height = canvas.offsetHeight * window.devicePixelRatio;
        };
        resize();
        window.addEventListener('resize', resize);

        const draw = (t) => {
            ctx.clearRect(0, 0, w, h);
            for (const p of particles) {
                p.x += p.vx;
                p.y += p.vy;
                if (p.y < -0.02) { p.y = 1.02; p.x = Math.random(); }
                if (p.x < -0.02) p.x = 1.02;
                if (p.x > 1.02) p.x = -0.02;
                const alpha = 0.25 + 0.25 * Math.sin(t * 0.0008 + p.tw);
                ctx.beginPath();
                ctx.arc(p.x * w, p.y * h, p.r * window.devicePixelRatio, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(124, 134, 240, ${alpha})`;
                ctx.fill();
            }
            raf = requestAnimationFrame(draw);
        };
        raf = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return <canvas ref={ref} className={`pointer-events-none ${className}`} aria-hidden="true" />;
}
